export class RandomUtils {
  public static generateId = () => `${Date.now()}-${Math.floor(Math.random() * 10000)}`;
}
